import { EnvironmentService } from 'phoenix/services/environmentService';

export function ControlClickDirective(
	$timeout:ng.ITimeoutService, 
	EnvironmentService:EnvironmentService
) {
	return {
		restrict: 'A',
		link: function($scope, $elm, $attrs) {
			//only on nontouch
			if (EnvironmentService.touchEnabled) {
				return;
			}

			var _mdListTargeted = false;
			retargetElement($elm);

			function click(event) {
				if (!event.ctrlKey) {
					return;
				}
				
				event.stopImmediatePropagation();	
				event.preventDefault();
				
				$scope.$apply(function(){
					$scope.$eval($attrs.pxOnControlClick);
				});
				
				if(_mdListTargeted){
					$elm.attr('disabled', true);
					$timeout(function(){
						$elm.removeAttr('disabled');	
					}, 600);
				}	
			}

			function retargetElement(elm){
				switch(elm[0].tagName){
					case 'MD-LIST-ITEM':
						_mdListTargeted = true;
						$timeout(function(){
							//timeout till the next digest cycle to verify all templates have rendered
							$elm = angular.element(elm[0].querySelector('button.md-button'));
							$elm.bind('mousedown', click);
						},0);
						break;
					default:
						$elm.bind('click', click);
				}
			}
			$scope.$on('$destroy',function(){
				$elm.unbind('click', click);
				if(_mdListTargeted){
					$elm.unbind('mousedown', click);
				}
			});
		}
	};
}

ControlClickDirective.$inject = [
	'$timeout', 
	'pxEnvironmentService'
];


// WEBPACK FOOTER //
// ./src/phoenix/components/onControlClick/onControlClick.ts